import { flow, types } from "mobx-state-tree";
import moment from "moment";
import { PaginationModel } from "../share/PagingModel";
import { OrganizeModel } from "./OrganizeModel";
import orgAPI from "./OrgService";

export const OrganizeChangeRequestListModel = types
    .model("OrganizeChangeRequestListModel", {
        list: types.optional(types.array(OrganizeModel), []),
        fromDate: types.optional(types.string, moment().subtract(5, "years").format()),
        toDate: types.optional(types.string, moment().add(5, "years").format()),
        requestStatus: types.optional(types.string, ""),
        paging: types.optional(PaginationModel, {
            pageSize: 10,
        }),
        loading: types.optional(types.boolean, false),
    })
    .actions((self: any) => ({
        getChangeRequestList: flow(function*() {
            try {
                self.loading = true;
                const result = yield orgAPI.getChangeRequestList({
                    fromDate: self.fromDate,
                    toDate: self.toDate,
                    requestStatus: self.requestStatus,
                    paging: self.paging,
                });
                self.list = result.data;
                self.setPagination(result);
            } catch (e) {
                throw e;
            } finally {
                self.loading = false;
            }
        }),
        setRequestStatus: (requestStatus: string) => {
            self.requestStatus = requestStatus;
        },
        onSelectedFilter: (value: any) => {
            self.setDefaultPagination();
            self.requestStatus = value;
            self.getChangeRequestList();
        },
        onSelectedPage: (pageNo: number) => {
            self.paging.pageNo = pageNo;
            self.getChangeRequestList();
        },
        setPagination: (data: any) => {
            self.paging.totalRow = data.totalRow;
            self.paging.pageSize = data.pageSize;
            self.paging.pageNo = data.pageNo;
        },
        setDefaultPagination: () => {
            self.paging.pageNo = 1;
        },
        resetAll: () => {
            self.list = [];
            self.paging = {
                pageSize: 10,
            };
        },
    }));

export type IOrganizeChangeRequestListModel = typeof OrganizeChangeRequestListModel.Type;
